export const getCookie = (name: string): string | null =>
  document.cookie.match(new RegExp("(^| )" + name + "=(?<value>[^;]+)"))?.groups
    ?.value ?? null;

export const hasCookie = (name: string): boolean => getCookie(name) !== null;

export const setCookie = (
  name: string,
  value: string | number,
  expirationDays = 365
): void => {
  const date = new Date();
  date.setTime(date.getTime() + expirationDays * 24 * 60 * 60 * 1000);
  const cookieConsent =
    name + "=" + value + "; expires=" + date.toUTCString() + "; path=/";
  document.cookie = cookieConsent;
};
